<template>
    <a-modal :title="processorname + '-主题管理'" :visible="isShow" width="650px" @cancel="handleCancel" :footer="null">

        <a-table id="myServiceTable" :columns="columns" :data-source="currentData" :pagination="false" :loading="tloading" :rowKey="(record,index)=>{return index}">

            <template slot="topic" slot-scope="text, record">
                <a-input v-if="record.type == 'new'" :max-length="32" v-model="record.topic"></a-input>
                <span v-else>{{record.topic}}</span>
            </template>

            <template slot="topicname" slot-scope="text, record">
                <a-input v-if="record.type == 'new'" :max-length="32" v-model="record.topicname"></a-input>
                <span v-else>{{record.topicname}}</span>
            </template>

            <template slot="operation" slot-scope="text, record">
                <a-button type="link" v-if="record.type == 'new'" @click="handleSave(record)">保存</a-button>
                <a-button type="link" v-if="record.type == 'new'" @click="handleRemove()">取消</a-button>

                <a-popconfirm title="确认删除?" v-if="record.type != 'new'" @confirm="() => handleDelete(record)">
                    <a class="tableLink" href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>

        <a-button type="primary" v-show="showNew" block class="mt20" @click="handleNew">
            <a-icon type="plus" />
            添加主题
        </a-button>
    </a-modal>
</template>
<script>
const columns = [
    {
        title: '序号',
        width: 80,
        align: 'center',
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '主题编码',
        width: 180,
        dataIndex: 'topic',
        align: 'left',
        ellipsises: true,
        scopedSlots: { customRender: 'topic' },
    },
    {
        title: '主题名称',
        width: 180,
        dataIndex: 'topicname',
        align: 'left',
        ellipsises: true,
        scopedSlots: { customRender: 'topicname' },
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    },
]

export default {
    data() {
        return {
            isShow: false,
            currentData: [],
            processor: '',
            processorname: '',
            columns,
            showNew: true,
            tloading: false,
        }
    },
    methods: {
        handleRemove() {
            this.currentData = this.currentData.filter((item) => {
                return item.type != 'new'
            })
            this.showNew = true
        },
        handleSave(item) {
            let that = this
            let params = {
                ...item,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'open/callbackAppManageAddTopic',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        this.init(that.processor, that.processorname)
                    }
                })
                .catch(() => {})
        },
        handleDelete(item) {
            let that = this
            let params = {
                ...item,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'open/callbackAppManageDelTopic',
                    params: params,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        this.init(that.processor, that.processorname)
                    }
                })
                .catch(() => {})
        },
        handleNew() {
            this.currentData.push({
                processor: this.processor,
                topicname: '',
                topic: '',
                type: 'new',
            })
            this.showNew = false
        },
        init(processor, processorname) {
            // debugger
            let that = this
            that.showNew = true
            that.processor = processor
            that.processorname = processorname
            let params = {
                processor,
                urlparams: false,
            }
            that.$store
                .dispatch({
                    type: 'open/callbackAppManageQueryTopics',
                    params: params,
                })
                .then((res) => {
                    debugger
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        that.currentData = result
                        that.showNew = result.length < 10
                        that.isShow = true
                    } else {
                        that.currentData = []
                        that.isShow = true
                    }
                })
                .catch(() => {
                    that.currentData = []
                    that.isShow = true
                })
        },
        handleCancel() {
            this.currentData = []
            this.isShow = false
        },
    },

    components: {},
    mounted() {},
}
</script>
<style scoped>
.trend_pagination {
    margin-top: 10px;
}

.tableLink {
    margin-right: 10px;
}

.topic_input {
    width: 200px;
    padding: 0 20px;
    font-weight: bolder;
}

.topic_item {
    padding-bottom: 20px;
}
</style>

